import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SidebarState {
    isCollapsed: boolean;
    toggleSidebar: () => void;
    setCollapsed: (collapsed: boolean) => void;
    expandedGroups: string[];
    toggleGroup: (group: string) => void;
    isDesktopCollapsed: boolean;
    toggleDesktopCollapse: () => void;
    setDesktopCollapse: (collapsed: boolean) => void;
}

export const useSidebarStore = create<SidebarState>()(
    persist(
        (set) => ({
            isCollapsed: false,
            toggleSidebar: () => set((state) => ({ isCollapsed: !state.isCollapsed })),
            setCollapsed: (collapsed: boolean) => set({ isCollapsed: collapsed }),
            expandedGroups: [], // Default to all collapsed
            toggleGroup: (group: string) => set((state) => {
                const isExpanded = state.expandedGroups.includes(group);
                return {
                    expandedGroups: isExpanded
                        ? state.expandedGroups.filter(g => g !== group)
                        : [...state.expandedGroups, group]
                };
            }),
            isDesktopCollapsed: false,
            toggleDesktopCollapse: () => set((state) => ({ isDesktopCollapsed: !state.isDesktopCollapsed })),
            setDesktopCollapse: (collapsed: boolean) => set({ isDesktopCollapsed: collapsed }),
        }),
        {
            name: 'admin-sidebar-storage',
            partialize: (state) => ({
                isDesktopCollapsed: state.isDesktopCollapsed,
                expandedGroups: state.expandedGroups
            }), // Only persist desktop state and expanded groups
        }
    )
);
